import React from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '6.5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2.5rem'
    }
  },
  textBox: {
    width: '65%',
    padding: '2.75rem 5.125rem ',
    borderTop: '1px black solid',
    borderBottom: '1px black solid',
    [theme.breakpoints.down('sm')]: {
      width: '86%',
      padding: '2rem 0'
    }
  },
  pg1: {
    marginTop: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem'
    }
  },
  bolded: {
    ...theme.typography.body2,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '28px'
    }
  },
  mobileH3: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      lineHeight: '18px'
    }
  },
  mobileBody1: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '28px',
      letterSpacing: '.5px'
    }
  }
}));

const Navigating = () => {
  const classes = useStyles();
  return (
    <Grid container direction="column" alignItems="center" className={classes.wrapper}>
      <Grid container direction="column" className={classes.textBox}>
        {/* <Grid item>
          <Typography variant="h3" className={classes.mobileH3}>
            NAVIGATING
          </Typography>
        </Grid> */}
        <Grid item className={classes.pg1}>
          <Typography variant="body1" className={classes.mobileBody1}>
            Enter Nikki, one of the health care navigators UnitedHealthcare trusts to help people
            like Pat along their health journey, through dedicated 1-on-1 support, to get the most
            from their Medicare benefits.
          </Typography>
        </Grid>
        <Grid item className={classes.pg1}>
          <Typography variant="body1" className={classes.mobileBody1}>
            <span className={classes.bolded}>NIKKI:</span> I love helping people. It's my passion to
            really help remove barriers in people's lives. I can help with medical, vision, dental,
            pharmacy, prior authorizations, community referrals. I'm kind of the one stop shop when
            it comes to supporting our health plan members.
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Navigating;
